import providers from "@/lib/api";
import config from "@/config";

export const userPublicDataFieldsWithStoryInfo = (): string => {
  let r = providers.UserPublicDataProvider.getFragment("UserPublicData");
  if (config.featureStories) r += "... on UserPublicData { hasStories firstNotViewedStoryId }";
  return r;
};

export const messageThreadFields = (): string => {
  let r = providers.UserPublicDataProvider.getFragment("MessageThread");
  if (config.featureStories)
    r += "... on MessageThread { users {... on UserPublicData { hasStories firstNotViewedStoryId }}}";
  return r;
};

export const feedFields = (): string => {
  return config.featureFeedPublicReview
    ? providers.ContentFeedProvider.getFragment("ContentFeed") +
        `... on ContentFeed { reviews { ${providers.ContentFeedProvider.getPageableFragment("Review")}}}`
    : "";
};

export const userWithAvatarFields = (data: { onlineStatus: boolean }): string => {
  return (
    providers.UserPublicDataProvider.getFragment("UserWithAvatar") +
    "... on UserPublicData { role " +
    (data.onlineStatus ? `onlineStatus { ${providers.OnlineStatusProvider.getFragment("OnlineStatus")} }` : "") +
    "}"
  );
};
